import { PlaceResponses, PlaceResult } from '@quromedical/places';
import { trpc } from 'trpc';

export class GooglePlaceApi {
  public getAddresses = async (search?: string): Promise<PlaceResponses> => {
    return await trpc.client.place.getAddress.query({
      search,
    });
  };

  public getPlaceDetails = async (placeId: string): Promise<PlaceResult> => {
    return await trpc.client.place.getPlace.query({
      placeId,
    });
  };
}
